import React, { useContext } from 'react';
import HeaderTheme1 from './variants/theme1';
import HeaderTheme2 from './variants/theme2';
import HeaderDfcVillage from './variants/dfcVillageTheme';
import { ThemeVariant } from '../../../hooks/useCompany';
import { HeaderProps } from './interfaces';
import { CheckoutContext, CheckoutContextProps } from '../../../context/CheckoutContext';
import SkeletonContentLoader from '../../shared/SkeletonContentLoader';
import HeaderSkeleton from './loading-skeleton';
import DfcVillageHeaderSkeleton from './variants/dfcVillageTheme/HeaderSkeleton';

const variantComponents: Record<ThemeVariant, React.ComponentType<any>> = {
  default: HeaderTheme1,
  theme1: HeaderTheme1,
  theme2: HeaderTheme2,
  marketplaceTheme: HeaderTheme1,
  dfcVillageTheme: HeaderDfcVillage,
};

const Header: React.FC<HeaderProps> = ({ company, isSidebarOpen, toggleDrawer, isLoading }) => {
  const { isLoadingCompany } = useContext(CheckoutContext) as CheckoutContextProps;
  const companyTheme = company?.theme;
  const Component = variantComponents[(companyTheme as ThemeVariant) || 'default'];

  const isHeaderLoading = isLoading || isLoadingCompany || !company;
  // Once the company is known to be on the DFC village theme, its own surface-aware skeleton
  // takes over — the shared white one flashes on the dark surface (plan §8.4). Before the
  // company has loaded we cannot know the theme, so the shared skeleton is the safe default.
  const skeleton =
    companyTheme === 'dfcVillageTheme' ? <DfcVillageHeaderSkeleton /> : <HeaderSkeleton />;

  return (
    <SkeletonContentLoader isLoading={isHeaderLoading} skeleton={skeleton}>
      <Component company={company} isSidebarOpen={isSidebarOpen} toggleDrawer={toggleDrawer} />
    </SkeletonContentLoader>
  );
};

export default Header;
